import { render } from "./EditShield.vue?vue&type=template&id=0edffb6a&lang=html"
import script from "./EditShield.vue?vue&type=script&lang=js"
export * from "./EditShield.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__